function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "img-send-info_module_svg__a",
  d: "M.019.231h62.35v55.093H.019z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#F2F3F7",
  cx: 89,
  cy: 89,
  r: 61
}), React.createElement("path", {
  d: "M61.44 87.909c-1.9 1.898-7.824 1.898-9.723 0l-24.866-18.65.232-.004 24.64 18.48c1.898 1.899 7.822 1.899 9.721 0l26.091-19.568 12.8-9.6-12.8-9.597V29.632l-16.694-13.8h-39.17a4.82 4.82 0 0 0-4.82 4.82v27.403L12.834 58.568l14.017 10.514v.177L12.834 58.745v47.903a3.95 3.95 0 0 0 3.951 3.952h79.596a3.952 3.952 0 0 0 3.953-3.952V58.745h-.01L61.438 87.909z",
  fill: "#FFF"
}), React.createElement("path", {
  fill: "#E9EAF0",
  d: "M87.233 52.094v16.242l10.828-8.12zM26.55 51.18l-12.053 9.04 12.053 9.04zM70.231 15.974v10.817a3.095 3.095 0 0 0 3.095 3.094h13.6"
}), React.createElement("path", {
  d: "M53.653 89.633c-1.04-.278-1.899-.71-2.475-1.264L12.334 59.236a.833.833 0 0 1 0-1.334l14.018-10.514a.833.833 0 1 1 1 1.334l-13.13 9.846 38 28.5c.032.023.061.05.09.078.715.716 2.394 1.18 4.271 1.18 1.88 0 3.555-.463 4.272-1.18a.665.665 0 0 1 .09-.078l38-28.5-11.909-8.931a.832.832 0 1 1 1-1.334l12.797 9.599a.83.83 0 0 1 0 1.332L61.988 88.368c-1.057 1.019-3.07 1.625-5.405 1.625-1.063 0-2.06-.126-2.93-.36",
  fill: "#C0C2CC"
}), React.createElement("g", {
  transform: "translate(26 14.769)"
}, React.createElement("mask", {
  id: "img-send-info_module_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#img-send-info_module_svg__a"
})), React.createElement("path", {
  d: "M.636 55.295a.833.833 0 0 1-.617-.805V5.884a5.614 5.614 0 0 1 1.655-3.997A5.617 5.617 0 0 1 5.672.23h39.17a.83.83 0 0 1 .53.19l16.695 13.8a.833.833 0 0 1 .302.642l-.001 38.535a.834.834 0 1 1-1.666 0V15.255L44.542 1.898H5.672a3.957 3.957 0 0 0-2.818 1.168 3.953 3.953 0 0 0-1.17 2.818l.002 48.606a.835.835 0 0 1-1.05.805",
  fill: "#C0C2CC",
  mask: "url(#img-send-info_module_svg__b)"
})), React.createElement("path", {
  d: "M69.234 33.655a3.91 3.91 0 0 1-2.894-3.77v-10.73a.835.835 0 0 1 1.667 0v10.73a2.242 2.242 0 0 0 2.236 2.236h13.49a.832.832 0 1 1 0 1.666h-13.49c-.349 0-.687-.046-1.009-.132M13.666 60.412l.001 46.237a3.12 3.12 0 0 0 3.118 3.117h79.597a3.122 3.122 0 0 0 3.119-3.117V60.405L61.983 88.543c-2.267 2.18-8.545 2.182-10.809-.001l-37.508-28.13zm1.881 50.859A4.792 4.792 0 0 1 12 106.649V58.745a.832.832 0 0 1 1.333-.666l38.885 29.163c.031.024.061.05.089.077 1.558 1.56 6.986 1.558 8.543 0a.805.805 0 0 1 .089-.076l38.885-29.164a.833.833 0 0 1 .514-.167h.01a.835.835 0 0 1 .819.834v47.903a4.79 4.79 0 0 1-4.785 4.784H16.785a4.77 4.77 0 0 1-1.238-.162z",
  fill: "#C0C2CC"
}), React.createElement("path", {
  d: "M95.082 105.114a.827.827 0 0 1-.283-.138L66.915 84.063a.834.834 0 0 1 .999-1.334l27.884 20.913a.834.834 0 0 1-.716 1.472M17.707 105.075a.831.831 0 0 1-.283-1.471l27.823-20.868a.834.834 0 0 1 .999 1.334l-27.823 20.867a.834.834 0 0 1-.716.138M35.999 52.793a.834.834 0 0 1 .217-1.638h41.956a.833.833 0 0 1 0 1.666H36.216a.817.817 0 0 1-.217-.028M61.588 44.363a.834.834 0 0 1 .217-1.64h16.367a.833.833 0 1 1 0 1.667H61.805a.817.817 0 0 1-.217-.027M35.999 60.478a.834.834 0 0 1 .217-1.638h41.956a.833.833 0 0 1 0 1.666H36.216a.817.817 0 0 1-.217-.028M35.998 68.162a.833.833 0 0 1 .217-1.638h41.957a.835.835 0 0 1 0 1.667l-41.957-.001a.817.817 0 0 1-.217-.028M36.432 44.388a.833.833 0 0 1-1.05-.805V28.728a3.908 3.908 0 0 1 3.903-3.902h16.667a.833.833 0 0 1 0 1.666H39.285a2.241 2.241 0 0 0-2.237 2.236v14.855a.835.835 0 0 1-.616.805",
  fill: "#C0C2CC"
}), React.createElement("path", {
  d: "M109.375 105.334c0 7.86-6.371 14.23-14.23 14.23-7.86 0-14.231-6.37-14.231-14.23 0-7.859 6.371-14.23 14.231-14.23 7.859 0 14.23 6.371 14.23 14.23",
  fill: "#FF4056"
}), React.createElement("path", {
  d: "M101.204 111.983a.834.834 0 0 1-.806-.215L88.711 100.08a.834.834 0 0 1 1.18-1.178l11.686 11.687a.833.833 0 0 1-.373 1.394",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M89.518 111.983a.834.834 0 0 1-.806-1.394L100.4 98.9a.834.834 0 0 1 1.179 1.179l-11.69 11.688a.823.823 0 0 1-.371.215",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M118.348 115.251a.817.817 0 0 1-.217.028h-6.44a.834.834 0 0 1 0-1.666h6.44a.832.832 0 1 1 .217 1.638M114.448 125.842a.838.838 0 0 1-.806-.215l-4.553-4.555a.834.834 0 0 1 1.178-1.178l4.554 4.554a.833.833 0 0 1-.373 1.394M103.857 129.74a.833.833 0 0 1-1.05-.805v-6.44a.833.833 0 0 1 1.666 0l.001 6.44c0 .386-.262.71-.617.806",
  fill: "#FF4056"
}));

var SvgImgSendInfoModule = function SvgImgSendInfoModule(props) {
  return React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150"
  }, props), _ref, _ref2);
};

export default SvgImgSendInfoModule;